// extracted by mini-css-extract-plugin
export default {"Header":"TelemetryAccessDenied_Header__kQsok","Text":"TelemetryAccessDenied_Text__fyryl","Card":"TelemetryAccessDenied_Card__iRpuJ","Logo":"TelemetryAccessDenied_Logo__HfGlf"};